export enum MenuPathsEnum {
  ROOT = "menu",
  PROFILE_INFORMATION = "profile-information",
  PAYMENT_HISTORY = "payment-history",
  SETTINGS = "settings",
  SECURITY = "security",
  "2FA_AUTH" = "2fa-authentication",
  EMAIL_PHONE = "email-phone",
  PASSWORD_UPDATE = "password-update",
  BIOMETRIC = "biometric",
  FEEDBACK = "feedback",
  AUTO_LOGOUT = "auto-logout",
}

export enum MenuRoutesEnum {
  ROOT = "/menu",
  PROFILE_INFORMATION = "/menu/profile-information",
  PAYMENT_HISTORY = "/menu/payment-history",
  SETTINGS = "/menu/settings",
  SECURITY = "/menu/security",
  "2FA_AUTH" = "/menu/security/2fa-authentication",
  EMAIL_PHONE = "/menu/security/email-phone",
  PASSWORD_UPDATE = "/menu/security/password-update",
  BIOMETRIC = "/menu/security/biometric",
  FEEDBACK = "/menu/feedback",
  AUTO_LOGOUT = "/menu/security/auto-logout",
}
